import React from 'react';
import { FormSectionProps, AVAILABLE_FACILITIES, AVAILABLE_FEATURES } from './types';

function FacilitiesSection({ formData, setFormData }: FormSectionProps) {
  return (
    <div className="border-t border-gray-200 pt-6">
      <h4 className="text-md font-medium text-gray-900 mb-4">Facilities & Features</h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Available Facilities
          </label>
          <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md p-3 space-y-2">
            {AVAILABLE_FACILITIES.map(facility => (
              <div key={facility} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id={`facility-${facility}`}
                  checked={formData.facilities?.includes(facility) || false}
                  onChange={(e) => {
                    const facilities = formData.facilities || [];
                    if (e.target.checked) {
                      setFormData(prev => ({ ...prev, facilities: [...facilities, facility] }));
                    } else {
                      setFormData(prev => ({ ...prev, facilities: facilities.filter(f => f !== facility) }));
                    }
                  }}
                  className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
                <label htmlFor={`facility-${facility}`} className="text-sm text-gray-700">
                  {facility}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Course Features
          </label>
          <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md p-3 space-y-2">
            {AVAILABLE_FEATURES.map(feature => (
              <div key={feature} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id={`feature-${feature}`}
                  checked={formData.features?.includes(feature) || false}
                  onChange={(e) => {
                    const features = formData.features || [];
                    if (e.target.checked) {
                      setFormData(prev => ({ ...prev, features: [...features, feature] }));
                    } else {
                      setFormData(prev => ({ ...prev, features: features.filter(f => f !== feature) }));
                    }
                  }}
                  className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
                <label htmlFor={`feature-${feature}`} className="text-sm text-gray-700">
                  {feature}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FacilitiesSection;